<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <back-arrow :title="$t('treasury.history')"
                      route-back="TreasuryIndex"/>
        </div>
        <b-button v-if="allowCreate" class="btn-medium" variant="primary" @click="clickOnCreateBtn">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a') }} {{ $t('solde') }}
        </b-button>
      </div>

      <b-card class="mt-4 mb-4 shadow-sm">

        <b122-table
          ref="B122TableSolde"
          :delete-item=allowDelete
          :edit-item=allowEdit
          :empty-button="$t('treasury.solde.emptyButton').toString()"
          :empty-title="$t('treasury.solde.emptyTitle').toString()"
          :fields="tableFields"
          get-b122-table-results-url="/treasury/getB122TableResults"
          identifier="B122TableSolde"
          init-b122-table-url="/treasury/initB122Table"
          :use-filters="false"
          :use-pagination="false"
          @add="clickOnCreateBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @setTotalCount="setTotalCount">
        </b122-table>
      </b-card>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="false"
      :selectedItem="selectedSolde"
      controllerName="treasury"
      itemSingularName="solde"
      itemSingularNameUpp="Solde"
      @didDeleteItem="didDeleteSolde()">
    </Item-delete-modal>
  </div>

</template>

<script>

import B122Table from "../../components/b122/B122Table";
import ItemDeleteModal from "../../components/b122/ItemDeleteModal";
import backArrow from "../../components/b122/BackArrow.vue";

export default {
  name: "TreasuryHistory",

  components: {
    B122Table,
    ItemDeleteModal,
    backArrow
  },

  data() {
    return {
      totalCount: 0,
      username: this.$store.getters.username,
      isEstateAgent: this.$store.getters.isEstateAgent,
      allowCreate: this.$store.getters.isEstateAgent,
      allowEdit: this.$store.getters.isEstateAgent,
      allowDelete: this.$store.getters.isEstateAgent,

      selectedSolde: null
    }
  },

  computed: {
    tableFields() {
      let tableFields = [
        {
          label: this.$t('treasury.solde.date'),
          key: 'date',
          sortable: true,
          formatter: function (value) {
            return new Date(value).toLocaleDateString()
          }
        },
        {
          label: this.$t('treasury.solde.value'),
          key: 'solde',
          sortable: true,
          formatter: function (value) {
            return Intl.NumberFormat().format((value).toFixed(2)) + " €"
          }
        },
        {
          label: this.$t('treasury.solde.creationDate'),
          key: 'creationDate',
          sortable: false,
          formatter: function (value) {
            return new Date(value).toLocaleDateString()
          }
        },
        {
          label: '',
          key: 'actions'
        }]
      return tableFields
    }

  },

  methods: {
    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'TreasuryCreateEdit'
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'TreasuryCreateEdit',
        params: {
          treasuryId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.selectedSolde = row.item
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteSolde() {
      this.selectedSolde = null
      this.$refs.B122TableSolde.refreshTable()
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/treasury/TreasuryHistory.vue